import {confirm, isConfirmed, isSent, sendCode} from '../../src/confirm-phone';
import {alert} from '../../src/alerts';
import {checkPhone} from '../../src/validation';

(function ($) {
    var review = function (context, callback) {
        return callback.call(context, $(context).closest('.review'));
    };

    var validate = function () {
        var error = false,
            name = $('.review__create-name').val(),
            phone = $('.review__create-phone').val(),
            message = $('#review__message').val();

        if (message.length < 20) {
            error = true;

            // Отзыв не может быть таким коротким
            alert(trans('reviews.form_text_short'), trans('reviews.form_text_short_caption'));
        }

        if (error === false && name.length < 3) {
            error = true;

            // Ваши имя может состоять не менее чем из 3-х букв
            alert(trans('reviews.form_name_short'), trans('reviews.form_name_short_caption'));
        }

        if (error === false && false === checkPhone(phone)) {
            error = true;
        }

        return error === false;
    };

    $(document).on('click', '.review__vote', function (event) {
        event.preventDefault();

        review(this, function ($el) {
            var mark = $(this).hasClass('plus') ? '-' : '+';

            $.ajax({
                url: '/reviews/send/',
                data: {id: $el.data('id'), mark: mark},
                type: 'post',
                async: false,
                success: function (response) {
                    if (response.status === 'success') {
                        $el.find('.review__rank').remove();
                        $el.find('.vote_block').append(response.rank_html);
                        $el.find('.review__vote.plus').addClass('plus_no');
                        $el.find('.review__vote.minus').addClass('minus_no');
                    } else if (response.hasOwnProperty('message')) {
                        // Ошибка
                        alert(response.message, trans('reviews.error'));
                    }
                },
                error: function ({responseJSON}) {
                    alert(responseJSON.message, trans('reviews.error'));
                },
            });
        });
    });

    $(document).on('click', '.review__vote-disabled', function (event) {
        event.preventDefault();

        alert($(this).data('message'), $(this).data('title'));
    });

    $(document).on('click', '.review__answer', function (event) {
        event.preventDefault();

        review(this, function ($el) {
            var container = $el.find('.review__answer-container');

            if (container.is(':visible')) {
                container.hide();
            } else {
                container.show();

                if (false === CKEDITOR.instances.hasOwnProperty('review__answer-' + $el.data('id'))) {
                    CKEDITOR.replace('review__answer-' + $el.data('id'));
                }
            }
        });
    });

    $(document).on('click', '.review__answer-send', function (event) {
        event.preventDefault();

        review(this, function ($el) {
            var text = CKEDITOR.instances['review__answer-' + $el.data('id')].getData();

            if (text.length < 20) {
                // Ответ не может быть таким коротким
                return alert(trans('reviews.form_answer_short'), trans('reviews.form_answer_short_caption'));
            }

            $.ajax({
                url: '/reviews/answer/',
                data: {id: $el.data('id'), text: text},
                type: 'post',
                async: false,
                success: function (response) {
                    if (response.status === 'success') {
                        window.location.reload();
                    } else {
                        // При сохранении отзыва произошла ошибка
                        alert(trans('reviews.save_error'), trans('reviews.save_error_caption'));
                    }
                },
            });
        });
    });

    $(document).on('click', '.review__create', function (event) {
        event.preventDefault();

        var phone = $('.review__create-phone').val();

        if (false === validate()) {
            return;
        }

        tracker.track('Книга отзывов => Нажатие "Добавить отзыв"');

        $('#otzyvBlock').show();

        sendCode(MOBILE_COD + phone, 'otzyv');

        $('#otzyvBlock').hide();

        if (isSent()) {
            $('#otzyvForm').hide();
            $('#otzyvForm2').show();
        }
    });

    $(document).on('click', '.review__create-confirm', function (event) {
        event.preventDefault();

        if (false === validate()) {
            return;
        }

        var cod = $('.review__create-code').val().replace(/[^\d]/gi, ''),
            name = $('.review__create-name').val(),
            phone = $('.review__create-phone').val(),
            message = $('#review__message').val();

        if (cod.length < 5 || cod.length > 6) {
            // Код должен содержать от 5-ти до 6-ти цифр. <br> И больше никаких символов
            return alert(trans('reviews.code_length_error'));
        }

        $(this).attr('disabled', true).trigger('refresh');

        $('.review__create-code').attr('disabled', true).trigger('refresh');

        confirm(MOBILE_COD + phone, 'otzyv', cod);

        $('.review__create-code').attr('disabled', false).trigger('refresh');

        if (isConfirmed()) {
            $.ajax({
                url: '/reviews/add/',
                data: {
                    cod: cod,
                    name: name,
                    phone: phone,
                    text: message,
                },
                type: 'post',
                async: false,
                success: function (response) {
                    if (response.status === 'success') {
                        location.href = '/kniga_otzivov/';
                    } else {
                        // При сохранении отзыва произошла ошибка
                        alert(trans('reviews.save_error'), trans('reviews.save_error_caption'));
                    }
                },
                error: function () {
                    alert(trans('reviews.save_error'), trans('reviews.save_error_caption'));
                },
            });
        } else {
            $(this).attr('disabled', false).trigger('refresh');
        }
    });

    $(document).ready(function () {
        var sendDeactivateAlert = function () {
            $.post('/reviews/deactivate-google-testimonial-alert/');
        };

        $.post(
            '/reviews/ask-for-google-testimonial/',
            function (response) {
                if (!response) {
                    return;
                }

                if (response.showBtn) {
                    $('#googleTestimonialBtn').attr('href', response.url).show();
                }

                if (response.showAlert) {
                    alert(
                        trans('reviews.modal_text_for_google'),
                        trans('reviews.modal_title_for_google'),
                        trans('reviews.modal_btn_for_google')
                    );

                    sendDeactivateAlert();
                }
            },
            'json'
        );
    });
})(jQuery);

$('.m_title .add_reviews').click(function () {
    if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        $('.add_revform').hide();
        return false;
    } else {
        tracker.track('Книга отзывов => Нажатие на кнопку "ВЫ МОЖЕТЕ ОСТАВИТЬ ОТЗЫВ"');

        $(this).addClass('active');
        $('.add_revform').show();
        return false;
    }
});
